import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { useEffect, useMemo, useState } from 'react';

function useGoogleMapsGeometry() {
  const [geometry, setGeometry] = useState(null);

  const GeometryLibrary = useMapsLibrary('geometry');
  const isGeometryLoaded = useMemo(() => geometry != null, [geometry]);

  useEffect(() => {
    if (!GeometryLibrary) return;
    const service = GeometryLibrary;

    if (service != null) {
      setGeometry(service);
    }
  }, [GeometryLibrary]);

  return {
    isGeometryLoaded,
    geometry,
  };
}

export { useGoogleMapsGeometry };
